import { useInfiniteQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContacts } from 'services/ContactService'
import { ContactEntityType, Contacts } from 'types/contacts'

interface ContactsInfiniteQueryProps {
  searchTerm?: string
  contactIds?: string[]
  type?: ContactEntityType
}

export const useContactsInfiniteQuery = ({
  searchTerm = '',
  contactIds = [],
  type,
}: ContactsInfiniteQueryProps) => {
  return useInfiniteQuery({
    queryKey: reactQueryKeys.contactsPayment(searchTerm, contactIds, type),
    queryFn: ({ pageParam = 0 }) =>
      getContacts({ size: 10, page: pageParam, searchQuery: searchTerm, contactIds, type }),
    getNextPageParam: (lastPage: Contacts) => {
      return lastPage?.pageable?.pageNumber + 1 < lastPage?.totalPages
        ? lastPage?.pageable.pageNumber + 1
        : undefined
    },
    initialPageParam: 0,
    select: data => {
      const contacts = data?.pages?.flatMap(page => page?.content)
      return contacts
    },
  })
}
